module.exports = __webpack_public_path__ + "img/20190819160840QQ截图20190819034122.e68ce19e.png";